import React from 'react';
import ReactDOM from 'react-dom';
import * as dotenv from 'dotenv';
import * as smoothscroll from 'smoothscroll-polyfill';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// Add polyfill to scroll with smoth
dotenv.config();
smoothscroll.polyfill();

// Registro do service worker: ver ServiceWorkerManager em App.tsx (atualização controlada).

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
